import React from "react";
import imgfor from "../images/forgot.png";
import { Link } from "react-router-dom";

const Forgot = () => {
  return (
    <div className="col-lg-7">
      <div className="login-page-right">
        <div className="right-div-12">
          <button className="Looking-bt">
            <Link
              to="https://edubridge.org.uk/how-it-works"
              className="text-white text-decoration-none"
              target="blank"
            >
              Looking for 1:1 tutoring?
            </Link>
          </button>
        </div>
        <img src={imgfor} className="forgot-img" alt="" />
      </div>
    </div>
  );
};
export default Forgot;
